import { FormEvent, useRef, useState } from 'react';
import { Button, Input, Toast } from 'antd-mobile';
import { EyeInvisibleOutline, EyeOutline } from 'antd-mobile-icons';
import SafeArea from '@/components/SafeArea';
import { login } from '@/api/auth';
import { useAuthStore } from '@/stores/authStore';
import { LockIcon, UserIcon } from '@/components/Icon';
import './styles.css';

export default function Login() {
  const { setAuth } = useAuthStore();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const submitting = useRef(false);

  const handleSubmit = async (event?: FormEvent) => {
    event?.preventDefault();
    if (submitting.current) return;
    if (!username.trim() || !password) {
      Toast.show({ content: '请输入用户名和密码', position: 'top' });
      return;
    }
    submitting.current = true;
    setLoading(true);
    try {
      const res = await login({ username: username.trim(), password });
      if (res.code === 0) {
        setAuth(res.data.token, res.data.user);
        Toast.show({ content: '登录成功', position: 'top' });
      } else {
        Toast.show({ content: res.message || '登录失败', position: 'top' });
      }
    } catch (error: any) {
      Toast.show({ content: error?.response?.data?.message || '登录失败', position: 'top' });
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };

  return (
    <main className="login-pro-page">
      <SafeArea className="login-pro-brand">
        <div
          className="login-pro-lockup"
        >
          <div className="login-pro-mark" aria-hidden="true">醉</div>
          <h1>汉州醉</h1>
          <p>白酒销售记账本</p>
        </div>
      </SafeArea>

      <section
        className="login-pro-sheet"
      >
        <div className="login-pro-heading">
          <h2>欢迎回来</h2>
          <p>请登录以继续使用</p>
        </div>

        <form className="login-pro-form" onSubmit={handleSubmit}>
          <label className="login-pro-field">
            <span className="login-pro-field__icon"><UserIcon /></span>
            <Input
              aria-label="用户名"
              autoComplete="username"
              disabled={loading}
              placeholder="用户名"
              value={username}
              onChange={setUsername}
              clearable
            />
          </label>

          <label className="login-pro-field">
            <span className="login-pro-field__icon"><LockIcon /></span>
            <Input
              aria-label="密码"
              autoComplete="current-password"
              disabled={loading}
              placeholder="密码"
              type={visible ? 'text' : 'password'}
              value={password}
              onChange={setPassword}
            />
            <button
              type="button"
              className="login-pro-visibility"
              aria-label={visible ? '隐藏密码' : '显示密码'}
              onClick={() => setVisible((current) => !current)}
            >
              {visible ? <EyeOutline /> : <EyeInvisibleOutline />}
            </button>
          </label>

          <Button
            block
            color="primary"
            size="large"
            loading={loading}
            disabled={loading}
            type="submit"
            className="login-pro-submit"
          >
            登录
          </Button>
        </form>

        <p className="login-pro-footer">汉州醉 · 专业经营记录</p>
      </section>
    </main>
  );
}
